import i18next from "i18next";
import authService from "../Services/authService";
import clinicService from "../Services/clinicService";
import utils from "../Utils";
import toast from "react-hot-toast";
import moment from "moment-timezone";
import { t } from "../Utils/translate";
import ClinicTiming from "../Components/manageClinic/clinicTiming/clinicTiming";

const changeLanguage = async (i18n, lng) => {
  try {
    i18n
      .changeLanguage(lng)
      .then(async () => {})
      .catch((e) => {});
  } catch (e) {}
};

function navigateToLogin() {
  toast.dismiss();
  toast.error("Session Expired", { toastId: "noSession" });
  localStorage.clear();
  setTimeout(() => {
    window.open("/stage/provider/#/", "_self");
  }, 2000);
}

const minimumGapMinutes = 15;
const minimumSessionDurationMinutes = 60;

function getTimeInDate(time) {
  let timeValue = time.replace("_", "0").replace("__", "00").replace("0_", "00");
  let [hour, min] = timeValue.split(":").map(Number);
  let finalValue = moment().startOf("day").add(hour, "hours").add(min, "minutes");
  return { timeValue, finalValue };
}

function checkTimeCollision(timingArr, timeArrIndex, clinicDetails, day) {
  let clinicTiming = clinicDetails.find((details) => details.dayOfWeek === day);
  if (!clinicTiming) {
    console.error("Clinic details for the specified day are not available");
    return { valid: false, error: "Clinic details not available for the specified day" };
  }

  const clinicOpeningTime = clinicTiming.opens;
  const clinicClosingTime = clinicTiming.closes;

  function timeToMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const clinicOpenMinutes = timeToMinutes(clinicOpeningTime);
  const clinicCloseMinutes = timeToMinutes(clinicClosingTime);
  const minimumGap = 15;

  for (let i = 0; i < timingArr.length; i++) {
    const timeSlot = timingArr[i];

    if ((i === timeArrIndex && (timeSlot.from === "__:__" || timeSlot.to === "__:__")) || (timeSlot.from === "__:__" && timeSlot.to === "__:__")) {
      continue;
    }

    const fromMinutes = timeToMinutes(timeSlot.from);
    const toMinutes = timeToMinutes(timeSlot.to);

    if (fromMinutes < clinicOpenMinutes || toMinutes > clinicCloseMinutes || fromMinutes >= toMinutes) {
      return { valid: false, error: "Doctor timing is not within clinic timings" };
    }

    if (i > 0) {
      const previousSlot = timingArr[i - 1];
      const previousToMinutes = timeToMinutes(previousSlot.to);
      if (fromMinutes - previousToMinutes < minimumGap) {
        return { valid: false, error: "Gap between sessions is less than 15 minutes" };
      }
    }
  }

  return { valid: true, error: "" };
}

function checkClinicTimeCollission(arr, editingTimeIndex) {
  const clinicStartTime = "00:00";
  const clinicEndTime = "24:00";
  let returnValue = true;
  let fromArr = arr[editingTimeIndex].from.split(":").map(Number);
  let toArr = arr[editingTimeIndex].to.split(":").map(Number);
  if (fromArr[0] > 23 || fromArr[1] >= 60 || toArr[0] > 23 || toArr[1] >= 60) {
    return false;
  }

  arr.forEach((item, index) => {
    if (editingTimeIndex === index) {
      let { finalValue: startUtc } = getTimeInDate(item.from);
      let { finalValue: endUtc } = getTimeInDate(item.to);

      let { finalValue: clinicStartUtc } = getTimeInDate(clinicStartTime);
      let { finalValue: clinicEndUtc } = getTimeInDate(clinicEndTime);

      if (startUtc.isBefore(clinicStartUtc) || endUtc.isAfter(clinicEndUtc)) {
        returnValue = false;
        return;
      }

      if (endUtc.diff(startUtc, "minutes") < minimumSessionDurationMinutes && item.to != "") {
        returnValue = false;
        return;
      }

      let collision = arr.some((item2, index2) => {
        if (index2 !== editingTimeIndex) {
          let { finalValue: otherStartUtc } = getTimeInDate(item2.from);
          let { finalValue: otherEndUtc } = getTimeInDate(item2.to);

          if (
            startUtc.isBetween(otherStartUtc, otherEndUtc) ||
            endUtc.isBetween(otherStartUtc, otherEndUtc) ||
            otherStartUtc.isBetween(startUtc, endUtc) ||
            otherEndUtc.isBetween(startUtc, endUtc) ||
            (startUtc.diff(otherEndUtc, "minutes") < minimumGapMinutes && otherEndUtc.isBefore(startUtc)) ||
            (otherStartUtc.diff(endUtc, "minutes") < minimumGapMinutes && endUtc.isBefore(otherStartUtc))
          ) {
            return true;
          }
        }
        return false;
      });

      if (collision) {
        returnValue = false;
      }
    }
  });
  return returnValue;
}

const checkIsMobileNumberValid = (countryCode, mobileNumber) => {
  if (mobileNumber && mobileNumber.length == 0) {
    return utils.strings.validations.mobileNumber;
  } else if (countryCode == "65" && mobileNumber.length < 8) {
    return utils.strings.validations.min_eight;
  } else if (countryCode == "91" && mobileNumber.length < 10) {
    return utils.strings.validations.min_ten;
  } else if (countryCode !== "65" && countryCode !== "91" && mobileNumber.length < 8) {
    return utils.strings.errorMsg.eight_err;
  } else {
    return "";
  }
};
function formatCount(count) {
  return count;
}

function getTime(dayList) {
  let arr = [...dayList];
  let bodyArr = [];
  let isTimeAdded = false;

  arr.map((item) => {
    let timeArr = [];
    item.timing.map((item2) => {
      let start = item2.from ? item2.from.replace("_", 0).split(":") : ["00", "00"];
      let end = item2.to ? item2.to.replace("_", 0).split(":") : ["00", "00"];

      let timeObj = {
        startHour: start[0],
        startMinute: start[1],
        endHour: end[0],
        endMinute: end[1],
        isActive: item2.status || false,
      };
      timeArr.push(timeObj);

      if (parseInt(start[0], 10) > 0 && parseInt(end[0], 10) > 0) {
        isTimeAdded = true;
      }
    });

    let obj = {
      day: item.day,
      isActive: item.status || false,
      timings: timeArr,
    };
    bodyArr.push(obj);
  });

  return bodyArr;
}

const utilFunctions = {
  changeLanguage,
  navigateToLogin,
  checkTimeCollision,
  getTimeInDate,
  checkIsMobileNumberValid,
  getTime,
  checkClinicTimeCollission,
  formatCount,
};

export default utilFunctions;
